export default "__VITE_PUBLIC_ASSET__cf61278c__"